import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { Table } from "../schema-builder/table/Table";
import { Migration } from "./Migration";
import { MssqlParameter } from "../driver/sqlserver/MssqlParameter";
import { ForbiddenTransactionModeOverrideError, TypeORMError } from "../error";
import { InstanceChecker } from "../util/InstanceChecker";
/**
 * Executes migrations: runs pending and reverts previously executed migrations.
 */
export var MigrationExecutor = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function MigrationExecutor(connection, queryRunner) {
    _classCallCheck(this, MigrationExecutor);
    this.connection = connection;
    this.queryRunner = queryRunner;
    // -------------------------------------------------------------------------
    // Public Properties
    // -------------------------------------------------------------------------
    /**
     * Indicates how migrations should be run in transactions.
     *   all: all migrations are run in a single transaction
     *   none: all migrations are run without a transaction
     *   each: each migration is run in a separate transaction
     */
    this.transaction = "all";
    var schema = this.connection.driver.options.schema;
    var database = this.connection.driver.database;
    this.migrationsDatabase = database;
    this.migrationsSchema = schema;
    this.migrationsTableName = connection.options.migrationsTableName || "migrations";
    this.migrationsTable = this.connection.driver.buildTableName(this.migrationsTableName, schema, database);
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Tries to execute a single migration given.
   */
  _createClass(MigrationExecutor, [{
    key: "executeMigration",
    value: function () {
      var _executeMigration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(migration) {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.withQueryRunner( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(queryRunner) {
                  var schemaBuilder;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this.createMigrationsTableIfNotExist(queryRunner);
                      case 2:
                        // create typeorm_metadata table if it's not created yet
                        schemaBuilder = _this.connection.driver.createSchemaBuilder();
                        if (!InstanceChecker.isRdbmsSchemaBuilder(schemaBuilder)) {
                          _context.next = 6;
                          break;
                        }
                        _context.next = 6;
                        return schemaBuilder.createMetadataTableIfNecessary(queryRunner);
                      case 6:
                        _context.next = 8;
                        return queryRunner.beforeMigration();
                      case 8:
                        _context.next = 10;
                        return migration.instance.up(queryRunner);
                      case 10:
                        _context.next = 12;
                        return queryRunner.afterMigration();
                      case 12:
                        _context.next = 14;
                        return _this.insertExecutedMigration(queryRunner, migration);
                      case 14:
                        return _context.abrupt("return", migration);
                      case 15:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function executeMigration(_x) {
        return _executeMigration.apply(this, arguments);
      }
      return executeMigration;
    }()
    /**
     * Returns an array of all migrations.
     */
  }, {
    key: "getAllMigrations",
    value: function () {
      var _getAllMigrations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", Promise.resolve(this.getMigrations()));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getAllMigrations() {
        return _getAllMigrations.apply(this, arguments);
      }
      return getAllMigrations;
    }()
    /**
     * Returns an array of all executed migrations.
     */
  }, {
    key: "getExecutedMigrations",
    value: function () {
      var _getExecutedMigrations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.withQueryRunner( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(queryRunner) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return _this2.createMigrationsTableIfNotExist(queryRunner);
                      case 2:
                        _context4.next = 4;
                        return _this2.loadExecutedMigrations(queryRunner);
                      case 4:
                        return _context4.abrupt("return", _context4.sent);
                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getExecutedMigrations() {
        return _getExecutedMigrations.apply(this, arguments);
      }
      return getExecutedMigrations;
    }()
    /**
     * Returns an array of all pending migrations.
     */
  }, {
    key: "getPendingMigrations",
    value: function () {
      var _getPendingMigrations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var allMigrations, executedMigrations;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.getAllMigrations();
            case 2:
              allMigrations = _context6.sent;
              _context6.next = 5;
              return this.getExecutedMigrations();
            case 5:
              executedMigrations = _context6.sent;
              return _context6.abrupt("return", allMigrations.filter(function (migration) {
                return !executedMigrations.find(function (executedMigration) {
                  return executedMigration.name === migration.name;
                });
              }));
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getPendingMigrations() {
        return _getPendingMigrations.apply(this, arguments);
      }
      return getPendingMigrations;
    }()
    /**
     * Inserts an executed migration.
     */
  }, {
    key: "insertMigration",
    value: function insertMigration(migration) {
      var _this3 = this;
      return this.withQueryRunner(function (q) {
        return _this3.insertExecutedMigration(q, migration);
      });
    }
    /**
     * Deletes an executed migration.
     */
  }, {
    key: "deleteMigration",
    value: function deleteMigration(migration) {
      var _this4 = this;
      return this.withQueryRunner(function (q) {
        return _this4.deleteExecutedMigration(q, migration);
      });
    }
    /**
     * Lists all migrations and whether they have been executed or not
     * returns true if there are unapplied migrations
     */
  }, {
    key: "showMigrations",
    value: function () {
      var _showMigrations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this5 = this;
        var hasUnappliedMigrations, queryRunner, executedMigrations, allMigrations, _iterator, _step, _loop;
        return _regeneratorRuntime().wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              hasUnappliedMigrations = false;
              queryRunner = this.queryRunner || this.connection.createQueryRunner(); // create migrations table if its not created yet
              _context8.next = 4;
              return this.createMigrationsTableIfNotExist(queryRunner);
            case 4:
              _context8.next = 6;
              return this.loadExecutedMigrations(queryRunner);
            case 6:
              executedMigrations = _context8.sent;
              // get all user's migrations in the source code
              allMigrations = this.getMigrations();
              _iterator = _createForOfIteratorHelper(allMigrations);
              _context8.prev = 9;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var migration, executedMigration;
                return _regeneratorRuntime().wrap(function _loop$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      migration = _step.value;
                      executedMigration = executedMigrations.find(function (executedMigration) {
                        return executedMigration.name === migration.name;
                      });
                      if (executedMigration) {
                        _this5.connection.logger.logSchemaBuild("[X] ".concat(executedMigration.id, " ").concat(migration.name));
                      } else {
                        hasUnappliedMigrations = true;
                        _this5.connection.logger.logSchemaBuild("[ ] ".concat(migration.name));
                      }
                    case 3:
                    case "end":
                      return _context7.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 12:
              if ((_step = _iterator.n()).done) {
                _context8.next = 16;
                break;
              }
              return _context8.delegateYield(_loop(), "t0", 14);
            case 14:
              _context8.next = 12;
              break;
            case 16:
              _context8.next = 21;
              break;
            case 18:
              _context8.prev = 18;
              _context8.t1 = _context8["catch"](9);
              _iterator.e(_context8.t1);
            case 21:
              _context8.prev = 21;
              _iterator.f();
              return _context8.finish(21);
            case 24:
              if (this.queryRunner) {
                _context8.next = 27;
                break;
              }
              _context8.next = 27;
              return queryRunner.release();
            case 27:
              return _context8.abrupt("return", hasUnappliedMigrations);
            case 28:
            case "end":
              return _context8.stop();
          }
        }, _callee7, this, [[9, 18, 21, 24]]);
      }));
      function showMigrations() {
        return _showMigrations.apply(this, arguments);
      }
      return showMigrations;
    }()
    /**
     * Executes all pending migrations. Pending migrations are migrations that are not yet executed,
     * thus not saved in the database.
     */
  }, {
    key: "executePendingMigrations",
    value: function () {
      var _executePendingMigrations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this6 = this;
        var queryRunner, schemaBuilder, executedMigrations, lastTimeExecutedMigration, allMigrations, successMigrations, pendingMigrations, migrationsOverridingTransactionMode, error, txModeDefault, _iterator2, _step2, migration, instanceTx, transactionStartedByUs, _iterator3, _step3, _loop2, _ret;
        return _regeneratorRuntime().wrap(function _callee9$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              queryRunner = this.queryRunner || this.connection.createQueryRunner(); // create migrations table if it's not created yet
              _context11.next = 3;
              return this.createMigrationsTableIfNotExist(queryRunner);
            case 3:
              // create the typeorm_metadata table if it's not created yet
              schemaBuilder = this.connection.driver.createSchemaBuilder();
              if (!InstanceChecker.isRdbmsSchemaBuilder(schemaBuilder)) {
                _context11.next = 7;
                break;
              }
              _context11.next = 7;
              return schemaBuilder.createMetadataTableIfNecessary(queryRunner);
            case 7:
              _context11.next = 9;
              return this.loadExecutedMigrations(queryRunner);
            case 9:
              executedMigrations = _context11.sent;
              // get the time when last migration was executed
              lastTimeExecutedMigration = this.getLatestTimestampMigration(executedMigrations); // get all user's migrations in the source code
              allMigrations = this.getMigrations(); // variable to store all migrations we did successfully
              successMigrations = []; // find all migrations that needs to be executed
              pendingMigrations = allMigrations.filter(function (migration) {
                // check if we already have executed migration
                var executedMigration = executedMigrations.find(function (executedMigration) {
                  return executedMigration.name === migration.name;
                });
                if (executedMigration) return false;
                // migration is new and not executed. now check if its timestamp is correct
                // if (lastTimeExecutedMigration && migration.timestamp < lastTimeExecutedMigration.timestamp)
                //     throw new TypeORMError(`New migration found: ${migration.name}, however this migration's timestamp is not valid. Migration's timestamp should not be older then migrations already executed in the database.`);
                // every check is passed means that migration was not run yet and we need to run it
                return true;
              }); // if no migrations are pending then nothing to do here
              if (pendingMigrations.length) {
                _context11.next = 20;
                break;
              }
              this.connection.logger.logSchemaBuild("No migrations are pending");
              // if query runner was created by us then release it
              if (this.queryRunner) {
                _context11.next = 19;
                break;
              }
              _context11.next = 19;
              return queryRunner.release();
            case 19:
              return _context11.abrupt("return", []);
            case 20:
              // log information about migration execution
              this.connection.logger.logSchemaBuild("".concat(executedMigrations.length, " migrations are already loaded in the database."));
              this.connection.logger.logSchemaBuild("".concat(allMigrations.length, " migrations were found in the source code."));
              if (lastTimeExecutedMigration) this.connection.logger.logSchemaBuild("".concat(lastTimeExecutedMigration.name, " is the last executed migration. It was executed on ").concat(new Date(lastTimeExecutedMigration.timestamp).toString(), "."));
              this.connection.logger.logSchemaBuild("".concat(pendingMigrations.length, " migrations are new migrations must be executed."));
              if (!(this.transaction === "all")) {
                _context11.next = 30;
                break;
              }
              // If we desire to run all migrations in a single transaction
              // but there is a migration that explicitly overrides the transaction mode
              // then we have to fail since we cannot properly resolve that intent
              // In theory we could support overrides that are set to `true`,
              // however to keep the interface more rigid, we fail those too
              migrationsOverridingTransactionMode = pendingMigrations.filter(function (migration) {
                var _a;
                return !(((_a = migration.instance) === null || _a === void 0 ? void 0 : _a.transaction) === undefined);
              });
              if (!(migrationsOverridingTransactionMode.length > 0)) {
                _context11.next = 30;
                break;
              }
              error = new ForbiddenTransactionModeOverrideError(migrationsOverridingTransactionMode);
              this.connection.logger.logMigration("Migrations failed, error: ".concat(error.message));
              throw error;
            case 30:
              // Set the per-migration defaults for the transaction mode
              // so that we have one centralized place that controls this behavior
              // When transaction mode is `each` the default is to run in a transaction
              // When transaction mode is `none` the default is to not run in a transaction
              // When transaction mode is `all` the default is to not run in a transaction
              // since all the migrations are already running in one single transaction
              txModeDefault = {
                each: true,
                none: false,
                all: false
              }[this.transaction];
              _iterator2 = _createForOfIteratorHelper(pendingMigrations);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  migration = _step2.value;
                  if (migration.instance) {
                    instanceTx = migration.instance.transaction;
                    if (instanceTx === undefined) {
                      migration.transaction = txModeDefault;
                    } else {
                      migration.transaction = instanceTx;
                    }
                  }
                }
                // start transaction if its not started yet
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              transactionStartedByUs = false;
              if (!(this.transaction === "all" && !queryRunner.isTransactionActive)) {
                _context11.next = 38;
                break;
              }
              _context11.next = 37;
              return queryRunner.startTransaction();
            case 37:
              transactionStartedByUs = true;
            case 38:
              _context11.prev = 38;
              _iterator3 = _createForOfIteratorHelper(pendingMigrations);
              _context11.prev = 40;
              _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                var migration;
                return _regeneratorRuntime().wrap(function _loop2$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      migration = _step3.value;
                      if (!_this6.fake) {
                        _context10.next = 5;
                        break;
                      }
                      _context10.next = 4;
                      return _this6.insertExecutedMigration(queryRunner, migration);
                    case 4:
                      return _context10.abrupt("return", "continue");
                    case 5:
                      if (!(migration.transaction && !queryRunner.isTransactionActive)) {
                        _context10.next = 9;
                        break;
                      }
                      _context10.next = 8;
                      return queryRunner.startTransaction();
                    case 8:
                      transactionStartedByUs = true;
                    case 9:
                      _context10.next = 11;
                      return migration.instance.up(queryRunner).catch(function (error) {
                        // informative log about migration failure
                        _this6.connection.logger.logMigration("Migration \"".concat(migration.name, "\" failed, error: ").concat(error === null || error === void 0 ? void 0 : error.message));
                        throw error;
                      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                        return _regeneratorRuntime().wrap(function _callee8$(_context9) {
                          while (1) switch (_context9.prev = _context9.next) {
                            case 0:
                              _context9.next = 2;
                              return _this6.insertExecutedMigration(queryRunner, migration);
                            case 2:
                              if (!(migration.transaction && transactionStartedByUs)) {
                                _context9.next = 5;
                                break;
                              }
                              _context9.next = 5;
                              return queryRunner.commitTransaction();
                            case 5:
                            case "end":
                              return _context9.stop();
                          }
                        }, _callee8);
                      }))).then(function () {
                        // informative log about migration success
                        successMigrations.push(migration);
                        _this6.connection.logger.logSchemaBuild("Migration ".concat(migration.name, " has been ").concat(_this6.fake ? "(fake)" : "", " executed successfully."));
                      });
                    case 11:
                    case "end":
                      return _context10.stop();
                  }
                }, _loop2);
              });
              _iterator3.s();
            case 43:
              if ((_step3 = _iterator3.n()).done) {
                _context11.next = 50;
                break;
              }
              return _context11.delegateYield(_loop2(), "t0", 45);
            case 45:
              _ret = _context11.t0;
              if (!(_ret === "continue")) {
                _context11.next = 48;
                break;
              }
              return _context11.abrupt("continue", 48);
            case 48:
              _context11.next = 43;
              break;
            case 50:
              _context11.next = 55;
              break;
            case 52:
              _context11.prev = 52;
              _context11.t1 = _context11["catch"](40);
              _iterator3.e(_context11.t1);
            case 55:
              _context11.prev = 55;
              _iterator3.f();
              return _context11.finish(55);
            case 58:
              if (!(this.transaction === "all" && transactionStartedByUs)) {
                _context11.next = 61;
                break;
              }
              _context11.next = 61;
              return queryRunner.commitTransaction();
            case 61:
              _context11.next = 74;
              break;
            case 63:
              _context11.prev = 63;
              _context11.t2 = _context11["catch"](38);
              if (!transactionStartedByUs) {
                _context11.next = 73;
                break;
              }
              _context11.prev = 66;
              _context11.next = 69;
              return queryRunner.rollbackTransaction();
            case 69:
              _context11.next = 73;
              break;
            case 71:
              _context11.prev = 71;
              _context11.t3 = _context11["catch"](66);
            case 73:
              throw _context11.t2;
            case 74:
              _context11.prev = 74;
              if (this.queryRunner) {
                _context11.next = 78;
                break;
              }
              _context11.next = 78;
              return queryRunner.release();
            case 78:
              return _context11.finish(74);
            case 79:
              return _context11.abrupt("return", successMigrations);
            case 80:
            case "end":
              return _context11.stop();
          }
        }, _callee9, this, [[38, 63, 74, 79], [40, 52, 55, 58], [66, 71]]);
      }));
      function executePendingMigrations() {
        return _executePendingMigrations.apply(this, arguments);
      }
      return executePendingMigrations;
    }()
    /**
     * Reverts last migration that were run.
     */
  }, {
    key: "undoLastMigration",
    value: function () {
      var _undoLastMigration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var queryRunner, schemaBuilder, executedMigrations, lastTimeExecutedMigration, allMigrations, migrationToRevert, transactionStartedByUs;
        return _regeneratorRuntime().wrap(function _callee10$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              queryRunner = this.queryRunner || this.connection.createQueryRunner(); // create migrations table if it's not created yet
              _context12.next = 3;
              return this.createMigrationsTableIfNotExist(queryRunner);
            case 3:
              // create typeorm_metadata table if it's not created yet
              schemaBuilder = this.connection.driver.createSchemaBuilder();
              if (!InstanceChecker.isRdbmsSchemaBuilder(schemaBuilder)) {
                _context12.next = 7;
                break;
              }
              _context12.next = 7;
              return schemaBuilder.createMetadataTableIfNecessary(queryRunner);
            case 7:
              _context12.next = 9;
              return this.loadExecutedMigrations(queryRunner);
            case 9:
              executedMigrations = _context12.sent;
              // get the time when last migration was executed
              lastTimeExecutedMigration = this.getLatestExecutedMigration(executedMigrations); // if no migrations found in the database then nothing to revert
              if (lastTimeExecutedMigration) {
                _context12.next = 14;
                break;
              }
              this.connection.logger.logSchemaBuild("No migrations was found in the database. Nothing to revert!");
              return _context12.abrupt("return");
            case 14:
              // get all user's migrations in the source code
              allMigrations = this.getMigrations(); // find the instance of the migration we need to remove
              migrationToRevert = allMigrations.find(function (migration) {
                return migration.name === lastTimeExecutedMigration.name;
              }); // if no migrations found in the database then nothing to revert
              if (migrationToRevert) {
                _context12.next = 18;
                break;
              }
              throw new TypeORMError("No migration ".concat(lastTimeExecutedMigration.name, " was found in the source code. Make sure you have this migration in your codebase and its included in the connection options."));
            case 18:
              // log information about migration execution
              this.connection.logger.logSchemaBuild("".concat(executedMigrations.length, " migrations are already loaded in the database."));
              this.connection.logger.logSchemaBuild("".concat(lastTimeExecutedMigration.name, " is the last executed migration. It was executed on ").concat(new Date(lastTimeExecutedMigration.timestamp).toString(), "."));
              this.connection.logger.logSchemaBuild("Now reverting it...");
              // start transaction if its not started yet
              transactionStartedByUs = false;
              if (!(this.transaction !== "none" && !queryRunner.isTransactionActive)) {
                _context12.next = 26;
                break;
              }
              _context12.next = 25;
              return queryRunner.startTransaction();
            case 25:
              transactionStartedByUs = true;
            case 26:
              _context12.prev = 26;
              if (this.fake) {
                _context12.next = 34;
                break;
              }
              _context12.next = 30;
              return queryRunner.beforeMigration();
            case 30:
              _context12.next = 32;
              return migrationToRevert.instance.down(queryRunner);
            case 32:
              _context12.next = 34;
              return queryRunner.afterMigration();
            case 34:
              _context12.next = 36;
              return this.deleteExecutedMigration(queryRunner, migrationToRevert);
            case 36:
              this.connection.logger.logSchemaBuild("Migration ".concat(migrationToRevert.name, " has been ").concat(this.fake ? "(fake)" : "", " reverted successfully."));
              // commit transaction if we started it
              if (!transactionStartedByUs) {
                _context12.next = 40;
                break;
              }
              _context12.next = 40;
              return queryRunner.commitTransaction();
            case 40:
              _context12.next = 53;
              break;
            case 42:
              _context12.prev = 42;
              _context12.t0 = _context12["catch"](26);
              if (!transactionStartedByUs) {
                _context12.next = 52;
                break;
              }
              _context12.prev = 45;
              _context12.next = 48;
              return queryRunner.rollbackTransaction();
            case 48:
              _context12.next = 52;
              break;
            case 50:
              _context12.prev = 50;
              _context12.t1 = _context12["catch"](45);
            case 52:
              throw _context12.t0;
            case 53:
              _context12.prev = 53;
              if (this.queryRunner) {
                _context12.next = 57;
                break;
              }
              _context12.next = 57;
              return queryRunner.release();
            case 57:
              return _context12.finish(53);
            case 58:
            case "end":
              return _context12.stop();
          }
        }, _callee10, this, [[26, 42, 53, 58], [45, 50]]);
      }));
      function undoLastMigration() {
        return _undoLastMigration.apply(this, arguments);
      }
      return undoLastMigration;
    }() // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Creates table "migrations" that will store information about executed migrations.
     */
  }, {
    key: "createMigrationsTableIfNotExist",
    value: function () {
      var _createMigrationsTableIfNotExist = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(queryRunner) {
        var tableExist;
        return _regeneratorRuntime().wrap(function _callee11$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!(this.connection.driver.options.type === "mongodb")) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return");
            case 2:
              _context13.next = 4;
              return queryRunner.hasTable(this.migrationsTable);
            case 4:
              tableExist = _context13.sent;
              if (tableExist) {
                _context13.next = 8;
                break;
              }
              _context13.next = 8;
              return queryRunner.createTable(new Table({
                database: this.migrationsDatabase,
                schema: this.migrationsSchema,
                name: this.migrationsTable,
                columns: [{
                  name: "id",
                  type: this.connection.driver.normalizeType({
                    type: this.connection.driver.mappedDataTypes.migrationId
                  }),
                  isGenerated: true,
                  generationStrategy: "increment",
                  isPrimary: true,
                  isNullable: false
                }, {
                  name: "timestamp",
                  type: this.connection.driver.normalizeType({
                    type: this.connection.driver.mappedDataTypes.migrationTimestamp
                  }),
                  isPrimary: false,
                  isNullable: false
                }, {
                  name: "name",
                  type: this.connection.driver.normalizeType({
                    type: this.connection.driver.mappedDataTypes.migrationName
                  }),
                  isNullable: false
                }]
              }));
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee11, this);
      }));
      function createMigrationsTableIfNotExist(_x4) {
        return _createMigrationsTableIfNotExist.apply(this, arguments);
      }
      return createMigrationsTableIfNotExist;
    }()
    /**
     * Loads all migrations that were executed and saved into the database (sorts by id).
     */
  }, {
    key: "loadExecutedMigrations",
    value: function () {
      var _loadExecutedMigrations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(queryRunner) {
        var mongoRunner, migrationsRaw;
        return _regeneratorRuntime().wrap(function _callee12$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!(this.connection.driver.options.type === "mongodb")) {
                _context14.next = 7;
                break;
              }
              mongoRunner = queryRunner;
              _context14.next = 4;
              return mongoRunner.databaseConnection.db(this.connection.driver.database).collection(this.migrationsTableName).find().sort({
                _id: -1
              }).toArray();
            case 4:
              return _context14.abrupt("return", _context14.sent);
            case 7:
              _context14.next = 9;
              return this.connection.manager.createQueryBuilder(queryRunner).select().orderBy(this.connection.driver.escape("id"), "DESC").from(this.migrationsTable, this.migrationsTableName).getRawMany();
            case 9:
              migrationsRaw = _context14.sent;
              return _context14.abrupt("return", migrationsRaw.map(function (migrationRaw) {
                return new Migration(parseInt(migrationRaw["id"]), parseInt(migrationRaw["timestamp"]), migrationRaw["name"]);
              }));
            case 11:
            case "end":
              return _context14.stop();
          }
        }, _callee12, this);
      }));
      function loadExecutedMigrations(_x5) {
        return _loadExecutedMigrations.apply(this, arguments);
      }
      return loadExecutedMigrations;
    }()
    /**
     * Gets all migrations that setup for this connection.
     */
  }, {
    key: "getMigrations",
    value: function getMigrations() {
      var migrations = this.connection.migrations.map(function (migration) {
        var migrationClassName = migration.name || migration.constructor.name;
        var migrationTimestamp = parseInt(migrationClassName.substr(-13), 10);
        if (!migrationTimestamp || isNaN(migrationTimestamp)) {
          throw new TypeORMError("".concat(migrationClassName, " migration name is wrong. Migration class name should have a JavaScript timestamp appended."));
        }
        return new Migration(undefined, migrationTimestamp, migrationClassName, migration);
      });
      this.checkForDuplicateMigrations(migrations);
      // sort them by timestamp
      return migrations.sort(function (a, b) {
        return a.timestamp - b.timestamp;
      });
    }
  }, {
    key: "checkForDuplicateMigrations",
    value: function checkForDuplicateMigrations(migrations) {
      var migrationNames = migrations.map(function (migration) {
        return migration.name;
      });
      var duplicates = Array.from(new Set(migrationNames.filter(function (migrationName, index) {
        return migrationNames.indexOf(migrationName) < index;
      })));
      if (duplicates.length > 0) {
        throw Error("Duplicate migrations: ".concat(duplicates.join(", ")));
      }
    }
    /**
     * Finds the latest migration (sorts by timestamp) in the given array of migrations.
     */
  }, {
    key: "getLatestTimestampMigration",
    value: function getLatestTimestampMigration(migrations) {
      var sortedMigrations = migrations.map(function (migration) {
        return migration;
      }).sort(function (a, b) {
        return (a.timestamp - b.timestamp) * -1;
      });
      return sortedMigrations.length > 0 ? sortedMigrations[0] : undefined;
    }
    /**
     * Finds the latest migration in the given array of migrations.
     * PRE: Migration array must be sorted by descending id.
     */
  }, {
    key: "getLatestExecutedMigration",
    value: function getLatestExecutedMigration(sortedMigrations) {
      return sortedMigrations.length > 0 ? sortedMigrations[0] : undefined;
    }
    /**
     * Inserts new executed migration's data into migrations table.
     */
  }, {
    key: "insertExecutedMigration",
    value: function () {
      var _insertExecutedMigration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(queryRunner, migration) {
        var values, mongoRunner, qb;
        return _regeneratorRuntime().wrap(function _callee13$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              values = {};
              if (this.connection.driver.options.type === "mssql") {
                values["timestamp"] = new MssqlParameter(migration.timestamp, this.connection.driver.normalizeType({
                  type: this.connection.driver.mappedDataTypes.migrationTimestamp
                }));
                values["name"] = new MssqlParameter(migration.name, this.connection.driver.normalizeType({
                  type: this.connection.driver.mappedDataTypes.migrationName
                }));
              } else {
                values["timestamp"] = migration.timestamp;
                values["name"] = migration.name;
              }
              if (!(this.connection.driver.options.type === "mongodb")) {
                _context15.next = 8;
                break;
              }
              mongoRunner = queryRunner;
              _context15.next = 6;
              return mongoRunner.databaseConnection.db(this.connection.driver.database).collection(this.migrationsTableName).insertOne(values);
            case 6:
              _context15.next = 11;
              break;
            case 8:
              qb = queryRunner.manager.createQueryBuilder();
              _context15.next = 11;
              return qb.insert().into(this.migrationsTable).values(values).execute();
            case 11:
            case "end":
              return _context15.stop();
          }
        }, _callee13, this);
      }));
      function insertExecutedMigration(_x6, _x7) {
        return _insertExecutedMigration.apply(this, arguments);
      }
      return insertExecutedMigration;
    }()
    /**
     * Delete previously executed migration's data from the migrations table.
     */
  }, {
    key: "deleteExecutedMigration",
    value: function () {
      var _deleteExecutedMigration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(queryRunner, migration) {
        var conditions, mongoRunner, qb;
        return _regeneratorRuntime().wrap(function _callee14$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              conditions = {};
              if (this.connection.driver.options.type === "mssql") {
                conditions["timestamp"] = new MssqlParameter(migration.timestamp, this.connection.driver.normalizeType({
                  type: this.connection.driver.mappedDataTypes.migrationTimestamp
                }));
                conditions["name"] = new MssqlParameter(migration.name, this.connection.driver.normalizeType({
                  type: this.connection.driver.mappedDataTypes.migrationName
                }));
              } else {
                conditions["timestamp"] = migration.timestamp;
                conditions["name"] = migration.name;
              }
              if (!(this.connection.driver.options.type === "mongodb")) {
                _context16.next = 8;
                break;
              }
              mongoRunner = queryRunner;
              _context16.next = 6;
              return mongoRunner.databaseConnection.db(this.connection.driver.database).collection(this.migrationsTableName).deleteOne(conditions);
            case 6:
              _context16.next = 11;
              break;
            case 8:
              qb = queryRunner.manager.createQueryBuilder();
              _context16.next = 11;
              return qb.delete().from(this.migrationsTable).where("".concat(qb.escape("timestamp"), " = :timestamp")).andWhere("".concat(qb.escape("name"), " = :name")).setParameters(conditions).execute();
            case 11:
            case "end":
              return _context16.stop();
          }
        }, _callee14, this);
      }));
      function deleteExecutedMigration(_x8, _x9) {
        return _deleteExecutedMigration.apply(this, arguments);
      }
      return deleteExecutedMigration;
    }()
  }, {
    key: "withQueryRunner",
    value: function () {
      var _withQueryRunner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(callback) {
        var queryRunner;
        return _regeneratorRuntime().wrap(function _callee15$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              queryRunner = this.queryRunner || this.connection.createQueryRunner();
              _context17.prev = 1;
              return _context17.abrupt("return", callback(queryRunner));
            case 3:
              _context17.prev = 3;
              if (this.queryRunner) {
                _context17.next = 7;
                break;
              }
              _context17.next = 7;
              return queryRunner.release();
            case 7:
              return _context17.finish(3);
            case 8:
            case "end":
              return _context17.stop();
          }
        }, _callee15, this, [[1,, 3, 8]]);
      }));
      function withQueryRunner(_x10) {
        return _withQueryRunner.apply(this, arguments);
      }
      return withQueryRunner;
    }()
  }]);
  return MigrationExecutor;
}();